import { ChangeDetectionStrategy, Component } from "@angular/core";

/**
 * Site-wide footer rendered at the bottom of every admin-web page.
 *
 * Fully justified: the copyright notice sits flush left and the
 * "Powered by" attribution flush right, spanning the full width.
 */
@Component({
  selector: "admin-footer",
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <footer class="admin-footer">
      <span class="admin-footer__copyright">
        Copyright &copy; 2026 All Rights Reserved.
      </span>
      <span class="admin-footer__powered-by"> </span>
    </footer>
  `,
  styles: [
    `
      :host {
        display: block;
        width: 100%;
      }
      .admin-footer {
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 16px;
        flex-wrap: wrap;
        width: 100%;
        padding: 12px 24px;
        color: var(--mat-sys-on-surface-variant);
        font-size: 12px;
        line-height: 1.4;
      }
    `,
  ],
})
export class FooterComponent {}
